import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    maxRows: { type: Number, default: 5 }
  }

  connect() {
    this.resize()
  }

  resize() {
    const styles = window.getComputedStyle(this.element)
    const lineHeight = Number.parseFloat(styles.lineHeight) || 20
    const padding = Number.parseFloat(styles.paddingTop) + Number.parseFloat(styles.paddingBottom)
    const border = Number.parseFloat(styles.borderTopWidth) + Number.parseFloat(styles.borderBottomWidth)
    const maxHeight = (lineHeight * this.maxRowsValue) + padding + border

    this.element.style.height = "auto"
    this.element.style.height = `${Math.min(this.element.scrollHeight, maxHeight)}px`
    this.element.style.overflowY = this.element.scrollHeight > maxHeight ? "auto" : "hidden"
  }
}
